<template>
    <div v-if="cardDetails" :class="type === 'CECourseTwo' || type === 'CECourseOne'? 'card-wrapper-two' : 'card-wrapper'">
    <div class="image-container" v-if="cardDetails.courseImageUrl">
        <img :src="require(`@/assets${cardDetails.courseImageUrl}`)" alt="Image" />
    </div>

    <div class="image-container" v-else>
        <img :src="cardDetails.courseImageUrl" alt="Image" />
    </div>

    <div class="content-container">
        <div class="date-title-container">
            <span class="event-date">{{ new Date(cardDetails.eventDateStart).toLocaleDateString() }}</span>
            <h4>{{ cardDetails.courseTitle }}</h4>
            <p>{{ cardDetails.description }}</p>
        </div>
        <div class="cta-container">
            <button @click="navigateToReg()" class="link" :class="[this.authenticated == true ? '' : 'learnMoreLink']" id="linkid">Learn more </button>
        </div>
    </div>
</div>
</template>

<script>
import {
    EventBus
} from "@/event-bus.js";
import {
    globalEventConsts,
    routeNameConstants
} from "@/constants.js";
import { useUserStore } from "@/stores/user.js"
import { useAgencyCarrierStore } from "@/stores/agencycarrier.js"

export default {
    name: "CECourseCard",
    setup() {
        const userStore = useUserStore();
        const agencyCarrierStore = useAgencyCarrierStore();
        return { userStore, agencyCarrierStore };
    },
    props: {
        cardDetails: Object,
         type: String
    },
    data() {
        return {
            authenticated: false
        }
    },
    methods: {
        async isAuthenticated() {
            this.authenticated = await this.$auth.isAuthenticated();
        },
        navigateToReg(){
            var course_title = this.cardDetails.courseTitle;
            var course_date= new Date(this.cardDetails.eventDateStart).toLocaleDateString().replace(/\//g, '-');
            
            var self = this;
            this.agencyCarrierStore.getAgenciesByAgentAsync({
                agentNumber: this.userStore.activeAgencyNumber,
                blocking: true
            }).then(function (response) {
                var agencyState = response.state;
                var eventLabel = `${course_title}/${course_date}/${agencyState}`;
                self.pushEventToGoogleDataLayer("continuing_education", "learn_more_clicked", eventLabel, "N/A");
                self.$router.navigate(self.navigationScenarioConstants.NAVIGATE_TO_CE_COURSE_REGISTRATION, {
                    CourseID: self.cardDetails.courseID
                });
            });
        },
    },
    created() {
        this.isAuthenticated();
        this.$auth.authStateManager.subscribe(this.isAuthenticated);
    }
};
</script>

<style lang="scss" scoped>
@import "@/styles/navigation/navigation-mixins.scss";

.card-wrapper-two{
     width: calc(50% - 20px) !important;
}

.card-wrapper,
.card-wrapper-two {
    flex: 0 0 auto;
    width: calc(33.3% - 20px);
    height: 415px;
    border-radius: 0px 0px 4px 4px;
    box-shadow: 0 0 $spacer-three 0 rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;

    .image-container {
        position: relative;
        min-height: 1px;

        img {
            width: 100%;
            height: 160px;
            display: block;
            border-radius: $spacer-two $spacer-two 0 0;
            object-fit: cover;
        }

        .cursor-pointer {
            &:hover {
                cursor: pointer;
            }
        }
    }

    .content-container {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-top: $spacer-four;
        padding-right: $spacer-five;
        padding-left: $spacer-five;
        padding-bottom: $spacer-five;

        .tag {
            @extend %nav-section-header;
        }

        .course-title {
            font-size: $spacer-five;
            line-height: $spacer-six;
            display: flex;
            color: black;
        }

        .event-date {
            color: $red-primary;
            font-size: 14px;
            text-transform: uppercase;
            font-weight: 500;
            letter-spacing: .75px;
            cursor: default;
            white-space: nowrap;
        }

        .link {
            line-height: $spacer-five + 4;
        }

        .learnMoreLink {
            cursor: default;
            pointer-events: none;
            text-decoration: none;
            color: grey;
        }

        h4,
        p {
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
            padding-bottom: $spacer-zero;
            margin-bottom: $spacer;
        }

        h4 {
            margin-top: $spacer;
            -webkit-line-clamp: 2;
            margin-bottom: 10px;
        }

        p {
            -webkit-line-clamp: 2;
            max-height: $spacer-eight;
        }

        .cta-container {
            button {
                background-color: $grayscale-eight;
            }
        }
    }

    @include tablet {
        width: calc(33.3% - 20px);
    }

}

@include wide-mobile {
    .card-wrapper,
    .card-wrapper-two {
        width: 100% !important;
        max-width:240px;
        height: 412px;

        img {
            height: 200px;
            width: 100%;
            object-fit: cover;
        }

        .content-container {
            padding-top: $spacer;
        }
    }
}
</style>
